import { render, staticRenderFns } from "./TabelaEmpresas.vue?vue&type=template&id=2826b052&scoped=true&"
import script from "./TabelaEmpresas.vue?vue&type=script&lang=js&"
export * from "./TabelaEmpresas.vue?vue&type=script&lang=js&"
import style0 from "./TabelaEmpresas.vue?vue&type=style&index=0&id=2826b052&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2826b052",
  null
  
)

export default component.exports